import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../components/button'
import { PageContainer } from '../../../../components/page-container/page-container'
import type { RootState } from '../../../../redux/global-store'
import { paths } from '../../../../router/paths'

import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { showToast } from '../../../../components/sonner'
import {
  getCollectionOrderStatusRequest,
  getCollectionOrderStatusReset,
} from '../../presentation/redux/actions/get-collection-order-status-actions'

export const TokenSent = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const createCollectionOrder = useSelector(
    (state: RootState) => state.createCollectionOrder.createCollectionOrder,
  )
  const getCollectionOrderStatus = useSelector(
    (state: RootState) => state.createCollectionOrder.getCollectionOrderStatus,
  )

  const [ellipsis, setEllipsis] = useState('.')

  const handleConfirmButton = () => {
    if (createCollectionOrder?.data) {
      dispatch(
        getCollectionOrderStatusRequest({
          collectionOrderId: createCollectionOrder?.data.collectionOrderId,
        }),
      )
    }
  }

  useEffect(() => {
    const id = setInterval(() => {
      setEllipsis(prev => (prev.length >= 3 ? '.' : prev + '.'))
    }, 500)
    return () => clearInterval(id)
  }, [])

  useEffect(() => {
    if (getCollectionOrderStatus?.success) {
      showToast('Token generado exitosamente', 'success')
      navigate(paths.collectionOrder.achReceived)
    }
  }, [getCollectionOrderStatus, navigate])

  useEffect(() => {
    if (getCollectionOrderStatus?.error) {
      dispatch(getCollectionOrderStatusReset())
      showToast(getCollectionOrderStatus?.error, 'error')
    }
  }, [getCollectionOrderStatus?.error])

  return (
    <>
      {getCollectionOrderStatus?.load ? (
        <PageContainer type="authenticated">
          <div className="bg-primary-darkest flex w-full items-center justify-center px-4 py-4">
            <p className="max-w-[300px] text-center text-[24px] leading-tight font-bold text-white">
              Esperando recibir la transferencia ACH
            </p>
          </div>
          <div className="flex w-full flex-col items-center px-6 pt-24 pb-10">
            <div className="flex flex-col items-center gap-10">
              <div className="flex justify-center py-2">
                <img
                  src={
                    'https://storage.googleapis.com/osb-files/dash/logo-primary.png'
                  }
                  alt="logo"
                  className="w-50 object-cover"
                />
              </div>
              <p className="text-lg font-medium text-[#0E161B]">
                Cargando{ellipsis}
              </p>
            </div>
          </div>
        </PageContainer>
      ) : (
        <PageContainer type="authenticated">
          <div className="flex w-full flex-col items-center px-6 pt-16 pb-10">
            <div className="flex w-full max-w-[380px] flex-col gap-12">
              <h2 className="py-2 text-center text-2xl font-bold">
                Este es el token enviado
              </h2>
              <h2 className="py-0 text-center text-5xl font-py-0 text-center text-5xl font-bold select-all cursor-text">
                {createCollectionOrder?.data.token}
              </h2>
              <div className="mx-auto w-full max-w-[340px] text-sm leading-relaxed">
                <p className="pb-4 text-base font-medium text-[#1D1D1D]">
                  Recuerda que nuestra cuenta para ACH es:
                </p>
                <div>
                  <p>
                    <span className="font-semibold">Banco:</span> NEXA
                  </p>
                  <p>
                    <span className="font-semibold">Cliente:</span> Finantec
                    Guatemala
                  </p>
                  <p>
                    <span className="font-semibold">Cuenta:</span> xxxxxxxxxxx
                  </p>
                  <p>
                    <span className="font-semibold">Descripción:</span> Ingresar
                    Token
                  </p>
                </div>
              </div>
              <div className="flex w-full justify-center pt-4">
                <Button
                  className="h-[55px] w-full max-w-[280px] rounded-[10px] text-2xl font-semibold"
                  onClick={() => handleConfirmButton()}
                >
                  Proseguir
                </Button>
              </div>
            </div>
          </div>
        </PageContainer>
      )}
    </>
  )
}
